import { Carousel } from '@design-system';
import { FC } from 'react';

import { InsightItem } from '../../utils/journals/insights';
import { JournalsCard } from '../Journals';

interface Props {
  insights: InsightItem[];
  onClick: (insight: InsightItem) => void;
  onSlide: (index: number) => void;
  title: string;
}

export const GlossaryInsights: FC<Props> = ({
  insights,
  onClick,
  onSlide,
  title,
}) => {
  if (insights.length === 0) {
    return null;
  }

  return (
    <Carousel
      headline={title}
      items={insights.map((insight) => (
        <JournalsCard
          description={insight.intro}
          href={`/${insight.full_slug}`}
          image={insight.image}
          imageRatio={insight.ratio || '4/3'}
          onClick={() => onClick(insight)}
          publishedAt={insight.date}
          readingTime={insight.readingTime}
          tag={insight.tag}
          title={insight.title}
        />
      ))}
      onSlide={onSlide}
    />
  );
};
